import React from "react";

import {
  type FixedDateInterval,
  todayLocalAsISODate,
  CompareDateRangeEnum,
  type DateRangeChoiceV2,
  type ICompareDateRangeEnum,
  resolveCompareDateRange,
} from "@north-beam/nb-common";
import { DateRangeDisplay, DateRangePicker } from "@shared/date-range-picker";
import { parseDateRangeArgument } from "@utils/index";

interface CompareDateRangeSelectProps {
  isLoading: boolean;
  dateRange: FixedDateInterval | DateRangeChoiceV2;
  compareDateRange: FixedDateInterval | ICompareDateRangeEnum;
  onUpdate: (opt: ICompareDateRangeEnum | FixedDateInterval) => void;
  maxLookbackDays?: number;
  popoverClassName?: string;
}

export const CompareDateRangeSelect = ({
  isLoading,
  dateRange,
  compareDateRange,
  onUpdate,
  maxLookbackDays,
  popoverClassName,
}: CompareDateRangeSelectProps) => {
  const anchor = todayLocalAsISODate();
  const dr = parseDateRangeArgument(dateRange, anchor);
  const cdr = resolveCompareDateRange(dr, compareDateRange);

  return (
    <div>
      <DateRangePicker
        popoverClassName={popoverClassName}
        label="COMPARE TO"
        disabled={isLoading}
        nonCustomChoices={CompareDateRangeEnum.reactSelectOptions}
        onUpdate={onUpdate}
        dateRange={compareDateRange}
        maxLookbackDays={maxLookbackDays}
        icon={<i className="fa-regular fa-sharp fa-calendars" />}
      />
      <div className="mt-0.5 text-xs font-light">
        <DateRangeDisplay
          dateRange={{ type: "fixed", ...cdr }}
          onConversionToFixed={onUpdate}
        />
      </div>
    </div>
  );
};
